import React, { useEffect, useState } from 'react'
import { getAllProject } from '../Common/apis';
import { toast } from 'react-toastify';
import moment from 'moment';
import Loader from '../Components/Loader/Loader';
import { Link } from 'react-router-dom';

function Project() {
    const [allProject, setAllProject] = useState(null)
    const [loading, setLoading] = useState(false);


    const fetchProject = async () => {
        setLoading(true);
        try {
            const response = await getAllProject();
            setAllProject(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchProject();
    }, []);



    return (
        <>
            {loading && <Loader />}
            <div className='mt-[80px]'>
                <div className='relative'>
                    <img src="/assets/gallery/img6.png" className='w-full' alt="" />
                    <div className='absolute md:bottom-[60px] bottom-[10px] left-[50%] translate-x-[-50%]'>
                        <h2 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#FFFFFF] tracking-[3px] text-center">Projects</h2>
                        <p className="font-[500] font-manrope text-[16px] text-[#FFFFFF] tracking-[3px] text-center">HOME-Projects</p>
                    </div>
                </div>
            </div>
            <section className='lg:pt-[90px] lg:pb-[158px] pb-[60px] pt-[40px] lg:px-[75px] px-[20px]'>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {allProject?.length === 0 ? (
                        <p className="text-center text-[#000000] font-manrope text-[18px] py-10">
                            No projects found.
                        </p>
                    ) : (
                        allProject?.map((item) => (
                            <Link to={`/project/project-detail/${item?._id}`} key={item?._id}>
                                <div className="relative">
                                    <img src={item?.Image} className='w-full h-[372px] rounded-[16px]' alt="" />
                                    <div className="absolute inset-0 bg-black bg-opacity-40 rounded-[16px]"></div>
                                    <div className="px-[20px] absolute w-full bottom-[20px]">
                                        <h6 className="font-[700] text-[20px] font-manrope text-[#FFFFFF] pb-[9px]">
                                            {item?.ProjectName}
                                        </h6>
                                        <div className="flex justify-between w-full items-center">
                                            <div className="flex items-center gap-[8px]">
                                                <img className='h-[29px] object-cover w-[29px] rounded-full' src={item?.UserImage} alt="" />
                                                <p className="font-[400] font-manrope text-[16px] text-[#FFFFFF]">
                                                    {item?.UserName}
                                                </p>
                                            </div>
                                            <p className="font-[400] font-manrope text-[16px] text-[#FFFFFF]">
                                                {moment(item?.createdAt).format('D MMMM YYYY')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))
                    )}
                </div>
            </section>
        </>
    )
}

export default Project